import * as React from "react";
import {Component} from "react";
import styles from "../../../styles/flyouts/superadmin/paper_sizes/Properties.scss";
import * as _ from "lodash";
import {withRouter} from "react-router";
import autobind from "autobind-decorator";
import {__, validateForm} from "../../../core/utils";
import {setNotification} from "../../../redux/actions/general/notification";
import {listCountries, updateCountry} from "../../../redux/actions/table/superadmin/countries";
import EditCountryForm from "../../../forms/superadmin/countries/EditCountryForm";
import {listLocalization} from "../../../redux/actions/localization";

@withRouter
class Properties extends Component {
    @autobind
    _handleSubmit(formData) {
        return validateForm(
            updateCountry(formData.id, _.omit(formData, ['id'])).then(() => {
                listCountries();

                this.props.readAction(formData.id);

                listLocalization();

                setNotification(__('companies-and-users.companies.flyout.properties.properties-saved'));
            })
        );
    }

    render() {
        const {data} = this.props;

        return (
            <div className={styles.scroller}>
                <EditCountryForm
                    onSubmit={this._handleSubmit}
                    initialValues={{
                        ..._.pick(data, ['id', 'name', 'region_id']),
                    }}
                />
            </div>
        );
    }
}

export default Properties;
